import React, { Component, Fragment } from "react";
import axios from "../../containers/api";
import { Row, Card, CardBody, CardTitle, Button } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import { Link } from "react-router-dom";
import Reserve from "../info-complemental/reserve-list/Reserve";
import ReserveJourney from "../../components/driver/ReserveJourney";
// 📊 Recharts
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
} from "recharts";

export default class DriverMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      agentStatistics: null,
      // TODO: replace with the driver's real active reserve id (from auth/router)

      activeDriverToFreighterId: 2020,
    };
  }

  componentDidMount() {
    console.log(this.state.activeDriverToFreighterId);
    // this.getAgentStatistics();
  }

  getAgentStatistics = () => {
    this.props.showSpinner();
    axios
      .get("api/StatisticsApi/GetAgentStatistics")
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ agentStatistics: res.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
      });
  };

  render() {
    // داده تستی برای نمودار خطی
    const chartData = [
      { name: "فروردین", reserves: 120 },
      { name: "اردیبهشت", reserves: 200 },
      { name: "خرداد", reserves: 150 },
      { name: "تیر", reserves: 300 },
      { name: "مرداد", reserves: 250 },
    ];
    return (
      <Fragment>
        <Row className="mb-3">
          <Colxx xxs="12">
            <Card>
              <CardBody className="d-flex flex-md-row flex-column">
                <Link to="/Cargos" type="button">
                  <Button outline color="success" className="mx-3 my-md-0 my-1">
                    اعلام بار ها
                  </Button>
                </Link>
                <Link to="/DriverReserves" type="button">
                  <Button outline color="success" className="mx-3 my-md-0 my-1">
                    رزرو های من
                  </Button>
                </Link>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        {/* 🚚 چرخه رزرو فعال راننده */}
        <Row className="mb-3">
          <Colxx xxs="12">
            <ReserveJourney
              driverToFreighterId={this.props.memberType.driverToFreighterId}
              showAlert={this.props.showAlert}
            />
          </Colxx>
        </Row>

        <Row className="mb-3">
          <Colxx xl="4" lg="12">
            <Card>
              <CardBody className="d-flex flex-column justify-content-center align-items-center">
                <CardTitle className="">تعداد کل اعلام بار</CardTitle>
                <div className="dashboard-card-numbers">
                  {this.state.agentStatistics &&
                    this.state.agentStatistics.totalReservesCount}
                  10
                </div>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" lg="12">
            <Card>
              <CardBody className="d-flex flex-column justify-content-center align-items-center">
                <CardTitle className="">تعداد کل رزرو من</CardTitle>
                <div className="dashboard-card-numbers">
                  {this.state.agentStatistics &&
                    this.state.agentStatistics.totalDraftsCount}
                  5
                </div>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" lg="12">
            <Card>
              <CardBody className="d-flex flex-column justify-content-center align-items-center">
                <CardTitle className="">تعداد کل رزرو غیر فعال</CardTitle>
                <div className="dashboard-card-numbers">
                  {this.state.agentStatistics &&
                    this.state.agentStatistics.totalValidBillsCount}
                  2
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        {/* 📊 نمودار خطی */}
        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle>آمار رزروها در ماه‌های اخیر</CardTitle>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart
                    data={chartData}
                    margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="reserves" stroke="#8884d8" />
                  </LineChart>
                </ResponsiveContainer>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}
